import React, { useState, useEffect, Children } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./nujobsSignedInFooter.scss";

export default function NuJobsSignedInFooter({}) {
  return (
    <div className="nuJobsSignedInFooter-form-wrapper">
        <div
        className="footer-menu"
        style={{
            marginTop: "20px",
            fontSize: "12px",
            color: "#666",
            lineHeight: "1.5",
            textAlign: "center",
        }}
        >
        <strong>Disclaimer:</strong> Applying through NuJobs does not guarantee
            selection, an interview, or employment. NuJobs does not permit employers to charge 
            candidates any fee for applying, interviewing, 
            or securing employment. Never make a payment to an employer 
            in connection with a job opportunity.
        </div>
        <div
        className="footer-menu"
        style={{
            marginTop: "10px",
            fontSize: "12px",
            textAlign: "center",
            color: "#666"
        }}
        >
        © 2026–2027 Copyright - NuJobs
        </div>
    </div>
    );
}
